import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {Title} from '@angular/platform-browser';
import {MatDialog} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {LeadCommentComponent} from '@module/favorites/leads/lead-comment/lead-comment.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {AlertService} from '@services/alert.service';
import {PublisherLead} from '@models/favorite';

// « Mes leads » : tous les leads reçus par un compte publieur, toutes annonces confondues
@Component({
    selector: 'app-my-leads',
    templateUrl: './my-leads.component.html',
    styleUrls: ['./my-leads.component.scss']
})
export class MyLeadsComponent implements OnInit {

    leads: PublisherLead[] = [];
    displayedColumns: string[] = ['created_at', 'name', 'email', 'mobile', 'status', 'ad', 'ad_status', 'city', 'price', 'comment'];
    dataSource = new MatTableDataSource<PublisherLead>([]);

    // Table derrière *ngIf : tri connecté via setter
    @ViewChild(MatSort) set matSort(sort: MatSort) {
        if (sort) {
            this.dataSource.sort = sort;
        }
    }
    statuses: string[] = [];
    loading = true;
    status = ''; // filtre statut ('' = tous)

    setStatus(status: string) {
        if (this.status === status) {
            return;
        }
        this.status = status;
        this.load();
    }

    constructor(private dialog: MatDialog, private adService: AdService, private alertService: AlertService, private titleService: Title) {
    }

    ngOnInit() {
        this.dataSource.sortingDataAccessor = (lead, column) => (this.constructor as any).sortAccessor(lead, column);
        this.titleService.setTitle('LyBox - Mes leads');
        this.load();
    }

    load() {
        this.loading = true;
        this.adService.getLeads('', this.status).subscribe(res => {
            this.leads = res.leads || [];
            this.dataSource.data = this.leads;
            if (res.statuses && res.statuses.length) {
                this.statuses = res.statuses;
            }
            this.loading = false;
        }, error => {
            this.loading = false;
            if (error != 'token_outdate') {
                this.alertService.error('Impossible de charger vos leads.');
            }
        });
    }

    openTuto() {
        this.dialog.open(TutoComponent, {
            width: '1000px',
            maxWidth: '100%',
            data: {video: 'leads'}
        });
    }

    openComment(lead: PublisherLead) {
        const dialogRef = this.dialog.open(LeadCommentComponent, {
            width: '480px',
            data: {lead},
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                lead.comment = result;
            }
        });
    }

    // Tri sur les champs imbriqués (intéressé, annonce)
    private static sortAccessor(lead: PublisherLead, column: string): string | number {
        switch (column) {
            case 'name':
                return lead.user ? ((lead.user.lastname || '') + ' ' + (lead.user.firstname || '')).toLowerCase() : '';
            case 'email':
                return lead.user ? (lead.user.email || '').toLowerCase() : '';
            case 'mobile':
                return lead.user ? (lead.user.mobile || '') : '';
            case 'ad':
                return lead.ad ? (lead.ad.title || '').toLowerCase() : '';
            case 'city':
                return lead.ad ? (lead.ad.city_name || '').toLowerCase() : '';
            case 'price':
                return lead.ad ? lead.ad.price : 0;
            case 'ad_status':
                return lead.ad && lead.ad.is_active ? 1 : 0;
            default:
                return lead[column];
        }
    }
}
